import { IUpdateStatus } from 'wisestep-api';

export const updateStatusQuery: IUpdateStatus = {
  active: false,
};

export enum OrganizationalScopeType {
  Teams = 'Teams',
  Account_Managers = 'Account Managers',
}
